/*
 * Klarna On-Site Messaging + Kaching Bundles
 * Übergibt den Preis des gewählten Bundles (z. B. "Kaufe 3 - zahle 2") an den Klarna-Hinweis,
 * statt des Einzelpreises der Variante. Ohne Kaching-Widget auf der Seite passiert nichts.
 */
(function() {
  var PLACEMENT_SELECTOR = 'klarna-placement[data-key="credit-promotion-badge"]';
  var BUNDLE_RADIO_SELECTOR = 'input[name^="kaching-bundles-deal"]:checked';
  var BUNDLE_PRICE_SELECTOR = '.kaching-bundles__bar-price .money';

  // "€89.98", "89,98 €", "1.234,56 €" -> Cent
  function parseCents(text) {
    var cleaned = (text || '').replace(/[^\d.,]/g, '');
    if (!cleaned) return null;
    var match = cleaned.match(/^(.*?)[.,](\d{2})$/);
    var euros = (match ? match[1] : cleaned).replace(/[.,]/g, '');
    var cents = match ? match[2] : '00';
    var value = parseInt(euros + cents, 10);
    return isNaN(value) ? null : value;
  }

  function selectedBundleCents() {
    var radio = document.querySelector(BUNDLE_RADIO_SELECTOR);
    if (!radio) return null;
    var bar = radio.closest('.kaching-bundles__bar') || radio.parentElement;
    var price = bar && bar.querySelector(BUNDLE_PRICE_SELECTOR);
    return price ? parseCents(price.textContent) : null;
  }

  function sync() {
    var cents = selectedBundleCents();
    if (!cents) return;
    document.querySelectorAll(PLACEMENT_SELECTOR).forEach(function(placement) {
      // Nur setzen, wenn abweichend – verhindert Schleifen mit der Klarna-App
      if (placement.getAttribute('data-purchase-amount') !== String(cents)) {
        placement.setAttribute('data-purchase-amount', String(cents));
      }
    });
  }

  var scheduled = null;
  function scheduleSync() {
    clearTimeout(scheduled);
    scheduled = setTimeout(sync, 50);
  }

  // Bundle-Auswahl, Variantenwechsel und Neu-Rendern des Kaching-Widgets
  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('click', scheduleSync, true);
  document.addEventListener('variant:change', scheduleSync);

  // Fängt ab, wenn Kaching die Preise nachlädt oder die Klarna-App den Betrag zurücksetzt
  new MutationObserver(scheduleSync).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['data-purchase-amount', 'checked']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
